<template>
  <div class="error-page not-found">
    <div class="error-content">
      <div class="img-wrap">
        <img src="@/assets/images/404.svg" alt="404" />
      </div>
      <div class="info-content">
        <div class="title">
          Page not found
        </div>
        <div class="caption">
          We can't seem to find the page you are looking for.
        </div>
        <div class="custom-button">
          <a href="javascript:void(0);" @click="goHome">
            {{ buttonLabel }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    buttonLabel() {
      if (this.onlyPlayer()) return "Back to profile list";
      return "Back Home";
    }
  },
  methods: {
    goHome() {
      if (this.onlyPlayer()) {
        this.$router.push("/profile");
        return;
      } else if (this.onlyClubCoach()) {
        this.$router.push(
          `/${localStorage["profile-id"]}/club_profile/summary`
        );
        return;
      } else if (this.onlyCollegeCoach()) {
        this.$router.push(
          `/${localStorage["profile-id"]}/college_profile/summary`
        );
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style>
.flex-centered {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.flex-centered i.fa {
  font-size: 60px;
  float: left;
  line-height: inherit;
  color: #e74634;
}
.flex-centered .detail {
  float: right;
  padding-left: 15px;
}
.flex-centered .title {
  font-size: 35px;
}
.flex-centered .description {
  font-size: 12px;
}
</style>
